import { useQuery } from 'react-query'
import { getParticipationGraph, getNetworkParticipationGraph } from '../Reports/apis/api-reports'
import { useReports } from '../Context/ReportsContext'
import { useCohorts } from './useCohorts'

export const useParticipation = () => {
    const { reportQuery, enabled, staleTime, isNetworkContext, networkId } = useReports()
    const { courseId, cohorts, from, to } = reportQuery
    const { networkCohorts } = useCohorts()

    // Get courseIds from network cohorts if in network context
    // Filter by selected cohort dates from reportQuery
    // Note: reportQuery.cohorts has YYYY-MM-DD format, nc.startDate has ISO format
    // If cohorts is empty, use all available networkCohorts (initial state)
    const selectedCohortIds = isNetworkContext
        ? networkCohorts
            ?.filter((nc) =>
                cohorts?.length === 0 || cohorts?.includes(nc.startDate.substring(0, 10))
            )
            .map((c) => c.courseIdMongo) || []
        : []

    // Choose API based on context
    const fetchFunction = isNetworkContext
        ? () => getNetworkParticipationGraph({ networkId: networkId as string, cohorts: selectedCohortIds, from, to })
        : () => getParticipationGraph(reportQuery)

    // Build query key with explicit from/to values
    const queryKey = isNetworkContext
        ? [networkId, 'Network Reports', 'Participation', 'Graph', `Cohorts: ${selectedCohortIds.join()}`, from, to]
        : [courseId, 'Reports', 'Participation', 'Graph', `Cohorts: ${cohorts?.join()}`, from, to]

    const { data: participation, ...rest } = useQuery(queryKey, fetchFunction, {
        enabled: isNetworkContext ? !!networkId && selectedCohortIds.length > 0 : enabled,
        staleTime: isNetworkContext ? 0 : staleTime, // No cache for network context to allow immediate refetch
    })

    return { participation, ...rest }
}
